export default {
  id: '681ad9cf26',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page th" data-name="transaction">\n\n    <!-- Navbar -->\n    <div class="navbar th__navbar no-shadow">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back th__back" aria-label="Back">\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\n          </a>\n        </div>\n        <div class="title th__navbar-title">History</div>\n        <div class="right"></div>\n      </div>\n    </div>\n\n    <div class="page-content th__content" data-type="';
      r += c(ctx_1.type, ctx_1);
      r += '">\n\n      <!-- Tabs -->\n      <div class="th__tabs">\n        <button type="button" class="th__tab th__tab--on" data-tab="payments">\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>\n          <span>Payments</span>\n        </button>\n        <button type="button" class="th__tab" data-tab="commissions">\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>\n          <span>Commissions</span>\n        </button>\n        <button type="button" class="th__tab" data-tab="withdrawals">\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>\n          <span>Withdrawals</span>\n        </button>\n      </div>\n\n      <!-- Status filter -->\n      <div class="th__filters">\n        <button type="button" class="th__filter th__filter--on" data-status="all">All <span class="th__filter-c">0</span></button>\n        <button type="button" class="th__filter" data-status="success">Success <span class="th__filter-c">0</span></button>\n        <button type="button" class="th__filter" data-status="pending">Pending <span class="th__filter-c">0</span></button>\n        <button type="button" class="th__filter" data-status="failed">Failed <span class="th__filter-c">0</span></button>\n      </div>\n\n      <!-- List (rendered by routes.js) -->\n      <div class="th__list"></div>\n\n      <div class="th__end-gap"></div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
/* ════════ TRANSACTION HISTORY (th__*) ════════ */
.th { background: #0A0A0B !important; }
.th__content {
  background:
    radial-gradient(130% 45% at 50% 0%, rgba(201,169,105,0.10) 0%, transparent 56%),
    #0A0A0B !important;
  padding: 14px 14px calc(40px + env(safe-area-inset-bottom)) !important;
  margin-top: 60px !important;
}
.th__navbar { background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important; }
.th__navbar .navbar-bg { background: transparent !important; }
.th__navbar-title { color: var(--gold) !important; font-weight: 700; }
.th__back { color: rgba(201,169,105,0.85) !important; }

/* Tabs */
.th__tabs {
  display: flex; gap: 6px; padding: 5px; border-radius: 15px;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.07);
}
.th__tab {
  flex: 1; min-width: 0; cursor: pointer;
  display: flex; flex-direction: column; align-items: center; gap: 4px;
  padding: 9px 4px; border-radius: 11px; border: none; background: transparent;
  color: rgba(255,255,255,0.55); font-size: 11px; font-weight: 700;
  transition: background .16s ease, color .16s ease;
}
.th__tab svg { opacity: 0.8; }
.th__tab--on {
  background: linear-gradient(155deg, rgba(201,169,105,0.20), rgba(201,169,105,0.06));
  color: #dfc288; box-shadow: 0 6px 16px -10px rgba(201,169,105,0.7);
}

/* Filters */
.th__filters { display: flex; gap: 8px; margin-top: 14px; overflow-x: auto; -webkit-overflow-scrolling: touch; }
.th__filters::-webkit-scrollbar { display: none; }
.th__filter {
  flex-shrink: 0; cursor: pointer;
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 13px; border-radius: 20px;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.6); font-size: 12px; font-weight: 600;
}
.th__filter-c {
  display: inline-flex; align-items: center; justify-content: center; min-width: 18px; height: 18px;
  padding: 0 5px; border-radius: 9px; font-size: 10px; font-weight: 800;
  background: rgba(255,255,255,0.08); color: rgba(255,255,255,0.55);
}
.th__filter--on {
  background: linear-gradient(155deg, rgba(201,169,105,0.20), rgba(201,169,105,0.06));
  border-color: rgba(201,169,105,0.45); color: #dfc288;
}
.th__filter--on .th__filter-c { background: rgba(201,169,105,0.25); color: #f3e2b6; }

/* List */
.th__list { margin-top: 16px; }
.th__item {
  display: flex; align-items: flex-start; gap: 12px; margin-bottom: 10px;
  padding: 13px 14px;
  background: linear-gradient(155deg, #161513 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.12); border-radius: 15px;
}
.th__item-ico {
  flex-shrink: 0; width: 38px; height: 38px; border-radius: 11px;
  display: flex; align-items: center; justify-content: center;
}
.th__item-ico--out { background: rgba(255,107,92,0.12); border: 1px solid rgba(255,107,92,0.2); color: #ff6b5c; }
.th__item-ico--in  { background: rgba(74,222,128,0.12); border: 1px solid rgba(74,222,128,0.2); color: #4ade80; }
.th__item-body { flex: 1; min-width: 0; }
.th__item-top { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; }
.th__item-title { font-size: 13.5px; font-weight: 700; color: #fff; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.th__item-amt { flex-shrink: 0; font-size: 14px; font-weight: 800; }
.th__item-amt--out { color: #fff; }
.th__item-amt--in { color: #4ade80; }
.th__item-meta { display: flex; align-items: center; gap: 8px; margin-top: 6px; flex-wrap: wrap; }
.th__badge { display: inline-flex; align-items: center; gap: 5px; padding: 3px 9px; border-radius: 20px; font-size: 10px; font-weight: 700; }
.th__badge-dot { width: 5px; height: 5px; border-radius: 50%; }
.th__badge--success { background: rgba(74,222,128,0.12); color: #4ade80; } .th__badge--success .th__badge-dot { background: #4ade80; }
.th__badge--pending { background: rgba(251,191,36,0.12); color: #fbbf24; } .th__badge--pending .th__badge-dot { background: #fbbf24; }
.th__badge--failed  { background: rgba(255,107,92,0.12); color: #ff6b5c; } .th__badge--failed .th__badge-dot { background: #ff6b5c; }
.th__item-sub { font-size: 11px; color: rgba(255,255,255,0.45); word-break: break-all; }
.th__item-extra {
  display: inline-block; margin-top: 7px; padding: 3px 9px; border-radius: 8px;
  background: rgba(201,169,105,0.10); border: 1px solid rgba(201,169,105,0.18);
  font-size: 11px; font-weight: 600; color: #dfc288;
}
.th__item-date { font-size: 10.5px; color: rgba(255,255,255,0.38); margin-top: 6px; }

/* loading / empty */
.th__loading { text-align: center; padding: 40px 20px; color: rgba(255,255,255,0.45); font-size: 13px; }
.th__empty { text-align: center; padding: 44px 20px; }
.th__empty-ico {
  width: 64px; height: 64px; border-radius: 50%; margin: 0 auto 14px;
  background: rgba(201,169,105,0.08); border: 1px solid rgba(201,169,105,0.18); color: rgba(201,169,105,0.7);
  display: flex; align-items: center; justify-content: center;
}
.th__empty-title { font-size: 15px; font-weight: 700; color: rgba(255,255,255,0.85); margin: 0; }
.th__empty-sub { font-size: 12px; color: rgba(255,255,255,0.45); margin: 6px 0 0; line-height: 1.5; }

.th__end-gap { height: 30px; }

/* ── Withdrawal card ── */
.th__wd-card {
  flex-direction: column; gap: 11px;
  padding: 14px 13px 13px;
}
.th__wd-head { display: flex; align-items: center; gap: 11px; }
.th__wd-info { flex: 1; min-width: 0; }
.th__wd-name {
  display: block; font-size: 13.5px; font-weight: 700; color: #fff;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.th__wd-dest {
  display: block; font-size: 11px; color: rgba(255,255,255,0.42); margin-top: 3px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.th__wd-breakdown {
  display: grid; grid-template-columns: 1fr 1px 1fr 1px auto;
  align-items: center;
  border-radius: 13px; overflow: hidden;
  border: 1px solid rgba(255,255,255,0.08);
  width: 95%; max-width: 100%; margin: 0 auto;
}
.th__wd-col {
  display: flex; flex-direction: column; align-items: center; gap: 5px;
  padding: 11px 6px;
  background: rgba(0,0,0,0.2);
}
.th__wd-col--net {
  background: linear-gradient(160deg, rgba(74,222,128,0.12), rgba(74,222,128,0.04));
  padding: 11px 12px;
}
.th__wd-sep { background: rgba(255,255,255,0.07); justify-self: stretch; }
.th__wd-lbl {
  font-size: 9px; font-weight: 600; color: rgba(255,255,255,0.35);
  text-transform: uppercase; letter-spacing: 0.04em; white-space: nowrap;
}
.th__wd-lbl--net { color: rgba(74,222,128,0.55); }
.th__wd-val { font-size: 13px; font-weight: 800; color: rgba(255,255,255,0.85); white-space: nowrap; }
.th__wd-val--fee { color: rgba(255,107,92,0.85); }
.th__wd-val--net { font-size: 15px; font-weight: 800; color: #4ade80; }
.th__wd-foot {
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
}
.th__wd-date { font-size: 10px; color: rgba(255,255,255,0.32); }
`,
  styleScoped: false
};